export type LatLng = { lat: number; lng: number }
export type AreaGeo = { paths: LatLng[]; markers: { position: LatLng }[] }

function isLatLng(v: unknown): v is LatLng {
    return (
        typeof v === 'object' &&
        v !== null &&
        typeof (v as LatLng).lat === 'number' &&
        typeof (v as LatLng).lng === 'number'
    )
}

/**
 * Chuẩn hóa dữ liệu vùng: `paths` là nguồn chân lý cho các đỉnh; `markers` luôn
 * suy lại từ `paths` để đảm bảo song song 1-1 (dữ liệu cũ có thể lệch độ dài
 * hoặc thiếu markers). Bỏ qua phần tử không hợp lệ.
 */
export function normalizeGeo(paths?: unknown[], markers?: unknown[]): AreaGeo {
    let cleanPaths = Array.isArray(paths) ? paths.filter(isLatLng) : []
    // Dữ liệu cũ có thể chỉ lưu toạ độ trong `markers` (paths rỗng) →
    // dựng lại paths từ markers[].position để không mất điểm.
    if (cleanPaths.length === 0 && Array.isArray(markers)) {
        cleanPaths = markers
            .map((mk) => (mk as { position?: unknown })?.position)
            .filter(isLatLng)
    }
    return {
        paths: cleanPaths,
        markers: cleanPaths.map((p) => ({ position: p })),
    }
}

export function addPoint(geo: AreaGeo, p: LatLng): AreaGeo {
    const paths = [...geo.paths, p]
    return { paths, markers: paths.map((x) => ({ position: x })) }
}

export function movePoint(geo: AreaGeo, index: number, p: LatLng): AreaGeo {
    const paths = geo.paths.map((x, i) => (i === index ? p : x))
    return { paths, markers: paths.map((x) => ({ position: x })) }
}

export function removePoint(geo: AreaGeo, index: number): AreaGeo {
    const paths = geo.paths.filter((_, i) => i !== index)
    return { paths, markers: paths.map((x) => ({ position: x })) }
}
